import React from 'react';
import { IconProps } from '../types/types';

const WABI: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 67" role="img" {...props}><path d="M33 8.564C19.397 8.564 8.565 19.647 8.565 33.5S19.649 58.436 33 58.436c13.603 0 24.435-11.083 24.435-24.936S46.603 8.564 33 8.564ZM33 67C14.863 67 0 51.887 0 33.5S14.863 0 33 0s33 15.113 33 33.5S51.137 67 33 67Z" fill="#FF5847"/><path d="M25.695 33.5 33 40.804l7.305-7.304L33 26.195 25.695 33.5ZM33 51.383c-1.008 0-2.267-.503-3.023-1.259L16.626 36.522c-1.763-1.763-1.763-4.281 0-6.045l13.351-13.601c1.764-1.763 4.283-1.763 6.046 0l13.351 13.601c1.763 1.764 1.763 4.282 0 6.046L36.023 50.123c-.756.756-2.015 1.26-3.023 1.26Z" fill="#FF5847"/></svg>
);

export default WABI;
